import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import labelService from "../services/labelService";

export default function DeleteLabelDialog({ open, setOpen, labelId, onDeleted }) {
  const [loading, setLoading] = React.useState(false);

  const handleConfirmDelete = async () => {
    if (!labelId) return;
    setLoading(true);
    try {
      await labelService.DELETE_Label_By_Id(labelId);
      onDeleted?.();
      setOpen(false);
    } catch (err) {
      console.error("Error deleting label:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      maxWidth="xs"
      fullWidth

      BackdropProps={{
        style: {
          backgroundColor: "rgba(255,255,255,0.2)",
         
        },
      }}
      PaperProps={{
        style: {
          borderRadius: 16,
          padding: "10px",
          background: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(2px)",
        },
      }}
    >
      <DialogTitle sx={{ fontWeight: 600, textAlign: "center" }}>
        Delete Label?
      </DialogTitle>
      <DialogContent>
        <Typography align="center">
          Are you sure you want to delete this label?
          <br />

          It will also be removed from all associated emails.

        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", gap: 2, pb: 2 }}>
        <Button
          variant="outlined"
          color="primary"
          onClick={() => setOpen(false)}
        >
          No, Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={handleConfirmDelete}
          disabled={loading}
        >
          {loading ? "Deleting..." : "Yes, Delete"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
